<div class="card bg-red-50">
  <div class="card-body bg-blue-50">
    <!-- Header with back button and language indicator -->
    <div class="card-body bg-blue-50">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <button
          class="btn btn-secondary d-flex align-items-center"
          (click)="goBack()"
        >
          <span class="material-icons me-1" title="Go Back">arrow_left</span>
          <span class="font-medium">Back</span>
        </button>

        <!-- Language indicator and dots -->
        <div class="d-flex align-items-center">
          <span class="me-2 font-medium">{{ currentLanguageDisplay }}</span>
          <div class="language-dots" *ngIf="availableLanguages.length > 1">
            <span
              *ngFor="let lang of availableLanguages; let i = index"
              class="dot"
              [class.active]="i === currentLanguageIndex"
              (click)="currentLanguageIndex = i"
            ></span>
          </div>
          <span class="text-muted" *ngIf="availableLanguages.length <= 1">Single language</span>
        </div>
      </div>
    </div>

    <!-- Preview content with navigation arrows -->
    <div class="preview-container">
      <!-- Left arrow -->
      <button
        class="nav-arrow nav-arrow-left"
        [class.disabled]="!canGoPrevious || isLoadingLanguages"
        (click)="previousLanguage()"
        [disabled]="!canGoPrevious || isLoadingLanguages"
      >
        <span class="material-icons">chevron_left</span>
      </button>

      <!-- Content area with swipe support -->
      <div
        class="content-wrapper flex flex-column justify-content-center p-4 bg-blue-50 mx-auto"
        (touchstart)="onTouchStart($event)"
        (touchmove)="onTouchMove($event)"
        (touchend)="onTouchEnd($event)"
        (mousedown)="onMouseDown($event)"
        (mouseup)="onMouseUp($event)"
      >
        <!-- Loading overlay -->
        <div *ngIf="isLoadingLanguages" class="loading-overlay">
          <p-progress-spinner></p-progress-spinner>
        </div>

        <!-- Dynamic blocks content -->
        <div *ngFor="let selectedBlock of currentBlocks">
          <div [ngSwitch]="selectedBlock.name">
            <!-- Your dynamic components -->
            <div *ngSwitchCase="'counter'">
              <app-counter [block]="selectedBlock" [isPreview]="true">
              </app-counter>
            </div>

            <div *ngSwitchCase="'paragraph-cta'">
              <app-paragraphcta [block]="selectedBlock" [isPreview]="true">
              </app-paragraphcta>
            </div>

            <div *ngSwitchCase="'voucher'">
              <app-voucher [block]="selectedBlock" [isPreview]="true">
              </app-voucher>
            </div>

            <div *ngSwitchCase="'main-banner'">
              <app-main-banner [block]="selectedBlock" [isPreview]="true">
              </app-main-banner>
            </div>

            <div *ngSwitchCase="'gift-voucher'">
              <app-giftvoucher [block]="selectedBlock" [isPreview]="true">
              </app-giftvoucher>
            </div>

            <div *ngSwitchCase="'property-usp-2x-photo'">
              <app-propertyusp2xphoto [block]="selectedBlock" [isPreview]="true">
              </app-propertyusp2xphoto>
            </div>

            <div *ngSwitchCase="'zigzag-no-heading-no-button'">
              <app-zigzag-no-heading-no-button
                [block]="selectedBlock"
                [isPreview]="true"
              >
              </app-zigzag-no-heading-no-button>
            </div>

            <div *ngSwitchCase="'zigzag-heading-and-cta'">
              <app-zigzag-heading-and-cta
                [block]="selectedBlock"
                [isPreview]="true"
              >
              </app-zigzag-heading-and-cta>
            </div>

            <div *ngSwitchCase="'zigzag-heading-and-alt-cta'">
              <app-zigzag-heading-and-alt-cta
                [block]="selectedBlock"
                [isPreview]="true"
              >
              </app-zigzag-heading-and-alt-cta>
            </div>

            <div *ngSwitchCase="'property-usp-1x-photo'">
              <app-propertyusp1xphoto [block]="selectedBlock" [isPreview]="true">
              </app-propertyusp1xphoto>
            </div>

            <div *ngSwitchCase="'property-description'">
              <app-property-description
                [block]="selectedBlock"
                [isPreview]="true"
              >
              </app-property-description>
            </div>

            <div *ngSwitchCase="'x2-prop-rec'">
              <app-x2-prop-rec [block]="selectedBlock" [isPreview]="true">
              </app-x2-prop-rec>
            </div>

            <div *ngSwitchCase="'heading'">
              <app-heading [block]="selectedBlock" [isPreview]="true">
              </app-heading>
            </div>

            <div *ngSwitchCase="'reservation'">
              <app-reservation [block]="selectedBlock" [isPreview]="true">
              </app-reservation>
            </div>

            <div *ngSwitchCase="'event'">
              <app-event [block]="selectedBlock" [isPreview]="true"> </app-event>
            </div>

            <div *ngSwitchCase="'experience-concierge'">
              <app-concierge [block]="selectedBlock" [isPreview]="true">
              </app-concierge>
            </div>

            <div *ngSwitchCase="'check-in'">
              <app-check-in [block]="selectedBlock" [isPreview]="true">
              </app-check-in>
            </div>

            <div *ngSwitchCase="'valamar-app'">
              <app-valamar-app [block]="selectedBlock" [isPreview]="true">
              </app-valamar-app>
            </div>

            <div *ngSwitchCase="'x2-experiences'">
              <app-x2-experiences [block]="selectedBlock" [isPreview]="true">
              </app-x2-experiences>
            </div>

            <div *ngSwitchCase="'x3-experiences'">
              <app-x3-experiences [block]="selectedBlock" [isPreview]="true">
              </app-x3-experiences>
            </div>

            <div *ngSwitchCase="'moments'">
              <app-moments [block]="selectedBlock" [isPreview]="true">
              </app-moments>
            </div>

            <div *ngSwitchCase="'inspiration'">
              <app-inspiration [block]="selectedBlock" [isPreview]="true">
              </app-inspiration>
            </div>

            <div *ngSwitchCase="'x2-prop-rec-onp'">
              <app-x2-prop-rec-onp [block]="selectedBlock" [isPreview]="true">
              </app-x2-prop-rec-onp>
            </div>

            <div *ngSwitchCase="'reviews'">
              <app-reviews [block]="selectedBlock" [isPreview]="true">
              </app-reviews>
            </div>

            <div *ngSwitchCase="'only-cta'">
              <app-only-cta [block]="selectedBlock" [isPreview]="true">
              </app-only-cta>
            </div>

            <div *ngSwitchCase="'disclaimer'">
              <app-disclaimer [block]="selectedBlock" [isPreview]="true">
              </app-disclaimer>
            </div>

            <div *ngSwitchCase="'only-intro'">
              <app-only-intro [block]="selectedBlock" [isPreview]="true">
              </app-only-intro>
            </div>

            <div *ngSwitchCase="'only-2-photos'">
              <app-only-2-photos [block]="selectedBlock" [isPreview]="true">
              </app-only-2-photos>
            </div>

            <div *ngSwitchCase="'sms'">
              <app-sms [block]="selectedBlock" [isPreview]="true"> </app-sms>
            </div>

             <div *ngSwitchCase="'push'">
              <app-push [block]="selectedBlock" [isPreview]="true"> </app-push>
            </div>

             <div *ngSwitchCase="'web-push'">
              <app-web-push [block]="selectedBlock" [isPreview]="true"> </app-web-push>
            </div>

             <div *ngSwitchCase="'viber'">
              <app-viber [block]="selectedBlock" [isPreview]="true"> </app-viber>
            </div>

             <div *ngSwitchCase="'rcs'">
              <app-rcs [block]="selectedBlock" [isPreview]="true"> </app-rcs>
            </div>

            <div *ngSwitchCase="'whatsapp'">
              <app-whatsapp [block]="selectedBlock" [isPreview]="true"> </app-whatsapp>
            </div>

            <div *ngSwitchDefault></div>
          </div>
        </div>
      </div>

      <!-- Right arrow -->
      <button
        class="nav-arrow nav-arrow-right"
        [class.disabled]="!canGoNext || isLoadingLanguages"
        (click)="nextLanguage()"
        [disabled]="!canGoNext || isLoadingLanguages"
      >
        <span class="material-icons">chevron_right</span>
      </button>
    </div>
  </div>
</div>
